export default __webpack_public_path__ + "static/media/KAIROS_30.0581466b.jpg";